/* swiper - hide swiper buttons element if both next and prev buttons are disabled */
document.addEventListener("DOMContentLoaded", function () {
const allSwiperButtons = document.querySelectorAll(".swiper-buttons");
allSwiperButtons.forEach(function (swiperButtons) {
const prevButton = swiperButtons.querySelector("[class^='swiper-button--prev'], [class*=' swiper-button--prev']");
const nextButton = swiperButtons.querySelector("[class^='swiper-button--next'], [class*=' swiper-button--next']");
if (prevButton && nextButton && prevButton.classList.contains("swiper-button-disabled") && nextButton.classList.contains("swiper-button-disabled")) {
swiperButtons.style.display = "none";
}
const grandParent = swiperButtons.parentElement.parentElement;
if (grandParent.classList.contains("section__foot") && !grandParent.querySelector("a.button")) {
grandParent.style.marginBlockStart = "0";
}
});
});
if (!customElements.get("product-card")) {
class ProductCard extends HTMLElement {
constructor() {
super();
this.isQuickCart = this.classList.contains(
"product-card--quick-cart"
);
this.init();
}
init() {
this.initForm();
this.initVariants();
this.imageBorderCalc();
if (
this.querySelector(".product-card__media") &&
this.querySelector(".product-card__media").classList.contains(
"product-card__media--hoverable"
)
) {
this.secondImgHoverStates();
}
this.initVideoHover();
if (!document.querySelector("quick-cart-drawer")) {
this.querySelector(".quick-cart-drawer__trigger")?.remove();
}
}
initForm() {
this.cart =
document.querySelector("cart-notification") ||
document.querySelector("cart-drawer");
this.addToCartForm = this.querySelector(
"form.product-card__add-to-cart--form"
);
if (this.addToCartForm) {
this.addToCartForm.removeAttribute("method");
this.addToCartForm.removeAttribute("action");
}
this.submitButton = this.querySelector('button[type="submit"]');
if (this.addToCartForm && !this.addToCartForm.hasListener) {
this.submitAddToCartFormHandler = this.submitAddToCartFormHandler || this.submitAddToCartForm.bind(this);
this.addToCartForm.addEventListener("submit", this.submitAddToCartFormHandler);
this.addToCartForm.hasListener = true;
}
}
submitAddToCartForm(event) {
event.preventDefault();
this.submitButton.setAttribute("disabled", "");
this.submitButton.classList.add("add-to-cart--is-disabled");
const config = fetchConfig("javascript");
config.headers["X-Requested-With"] = "XMLHttpRequest";
delete config.headers["Content-Type"];
const formData = new FormData(event.target);
if (this.cart) {
formData.append(
"sections",
this.cart
.getSectionsToRender()
.map(section => section.section)
);
if (this.hasAttribute('data-has-pre-order')) {
formData.append('properties[Pre-order]', '✓');
}
formData.append("sections_url", window.location.pathname);
this.cart.setActiveElement(document.activeElement);
}
config.body = formData;
fetch(`${routes.cart_add_url}`, config)
.then(response => response.json())
.then(response => {
if (response.errors) {
this.handleErrorMessage(response.errors);
return;
}
if (this.cart) {
this.cart.renderContents(response);
}
updateCartCounters();
})
.catch((error) => { console.error(error) })
.finally(() => {
this.submitButton.removeAttribute("disabled");
this.submitButton.classList.remove(
"add-to-cart--is-disabled"
);
const quickCartDrawer = this.closest("quick-cart-drawer");
if (quickCartDrawer) {
quickCartDrawer.close();
}
});
}
handleErrorMessage(errorMessage = false) {
this.errorMessageWrapper = this.querySelector(
".product-form__error-message-wrapper"
);
if (!this.errorMessageWrapper) return;
this.errorMessage = this.errorMessageWrapper.querySelector(
".product-form__error-message"
);
this.errorMessageWrapper.toggleAttribute(
"hidden",
!errorMessage
);
if (errorMessage) {
this.errorMessage.textContent = errorMessage;
}
setTimeout(() => {
this.resetErrorMessage();
}, 5000);
}
resetErrorMessage() {
if (!this.errorMessageWrapper) return;
this.errorMessageWrapper.toggleAttribute("hidden", true);
this.errorMessageWrapper.textContent = "";
}
initVariants() {
this.getVariantsData();
this.querySelectorAll(".button--variant input").forEach(
variantButton => {
variantButton.addEventListener(
"click",
this.onClickOptionRadioInputs.bind(this)
);
}
);
let initialCheckedOptions = [];
this.querySelectorAll(".variant-option-radio-input").forEach(
radioInput => {
if (radioInput.checked) {
initialCheckedOptions.push(radioInput.value);
}
}
);
if (initialCheckedOptions.length === 0) {
this.querySelector(".variant-option-radio-input")?.click();
}
this.updateVariantStatuses();
const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();
if (!this.querySelector(".product-card__media")?.dataset.updateMedia) {
this.updateMediaForVariant(currentVariantId);
}
this.setCartButtonState();
}
/*
 * RR 24 Aug 2026. Rewritten.
 *
 * WHAT WAS WRONG
 * The old pass skipped the first option entirely, so a size with nothing in
 * stock stayed selectable. Worse, it never SNAPPED. It would correctly mark a
 * later option as unavailable and then leave it selected, so the customer sat
 * on a combination that does not exist. ELEMENT SHORT is 91 variants out of a
 * possible 240, because only Black is made in the 7 inch and V1 inseams, so
 * that is the normal case there rather than an edge case. From an impossible
 * combination, ProductCard.updateFormVariantIdInput() finds no match and skips
 * its write, leaving the PREVIOUS variant id in the hidden input, and nothing
 * disables the button. The customer pressed Add to Cart and bought the last
 * thing that happened to resolve. Wrong item picked, packed and shipped.
 *
 * WHAT IT DOES NOW
 * Each option position is constrained by every position before it, the first
 * one included, and availability means a real variant that is actually in
 * stock. So "does not exist" and "sold out" are treated the same, which is what
 * a customer needs: a button they can press is a thing they can buy.
 *
 * Then it snaps. If the value selected in a position is no longer available,
 * the selection moves to the first one that is, and the pass runs again because
 * everything after it depends on that choice. The loop is bounded by the number
 * of option rows, so it cannot spin.
 *
 * The result is that the selection is always a real, in stock variant, which is
 * what closes the wrong item hole at the root rather than papering over it.
 *
 * If the product has nothing in stock at all, it leaves the picker exactly as
 * the server rendered it. Hiding every button would read as broken rather than
 * as sold out.
 */
updateVariantStatuses() {
const variants = this.variantsObj;
if (!variants || !variants.length) return;

const wrappers = [
...this.querySelectorAll(".js-product-card-options")
];
if (!wrappers.length) return;

const anythingInStock = variants.some(variant => variant.available);
if (!anythingInStock) return;

/*
 * RR 24 Aug 2026. An option the customer cannot see is not a choice they made,
 * so it must not narrow the ones they can see.
 *
 * On a collection card, snippets/card-product.liquid renders a fieldset for
 * every option but wraps the non swatch ones in visually-hidden. Only the
 * colour swatches are on screen. The cascade was still constraining colour by
 * the hidden Size fieldset, whose checked value is just whatever the first
 * available variant happens to be, so ELEMENT SHORT crossed out five of its
 * eight colours because they are out of stock in Small. They are in stock in
 * other sizes, and size is the product page's question.
 *
 * In the quick add drawer every fieldset is visible, so nothing changes there.
 */
const visible = wrappers.map(wrapper => {
const row = wrapper.closest("li") || wrapper.parentElement;
if (!row || !row.classList) return true;
// Exact tokens only. visually-hidden--desktop and visually-hidden--mobile
// hide a row at ONE breakpoint and it is still a real choice at the other,
// so a prefix match here would wrongly skip the colour row on whichever
// breakpoint it is shown.
return !row.classList.contains("hidden") &&
!row.classList.contains("visually-hidden");
});

for (let pass = 0; pass <= wrappers.length; pass += 1) {
const checked = wrappers.map(
wrapper =>
wrapper.querySelector('input[type="radio"]:checked')?.value
);
let snapped = false;

wrappers.forEach((wrapper, index) => {
// leave a hidden row exactly as the server rendered it
if (!visible[index]) return;

const inputs = [
...wrapper.querySelectorAll('input[type="radio"]')
];
const available = variants
.filter(variant => {
if (!variant.available) return false;
for (let before = 0; before < index; before += 1) {
if (!visible[before]) continue;
if (
checked[before] != null &&
variant[`option${before + 1}`] !== checked[before]
) {
return false;
}
}
return true;
})
.map(variant => variant[`option${index + 1}`]);

this.setInputAvailability(inputs, available);

const current = wrapper.querySelector(
'input[type="radio"]:checked'
);
if (current && !available.includes(current.value)) {
const fallback = inputs.find(input =>
available.includes(input.value)
);
if (fallback && fallback !== current) {
current.checked = false;
current.removeAttribute("checked");
fallback.checked = true;
fallback.setAttribute("checked", "");
const legendValue = wrapper.querySelector(
"legend [data-selected-variant], legend [data-selected-value]"
);
if (legendValue) legendValue.textContent = fallback.value;
snapped = true;
}
}
});

if (!snapped) break;
}
}
setInputAvailability(elementList, availableValuesList) {
elementList.forEach(element => {
const value = element.getAttribute("value");
const availableElement = availableValuesList.includes(value);
element
.closest("li")
.classList.toggle("disabled", !availableElement);
element.toggleAttribute("disabled", !availableElement);

/*
 * RR 24 Aug 2026. Hide rather than strike through.
 * .button--variant is the wrapper around one option. The closest("li")
 * above is the row holding the whole fieldset, so that class has always
 * landed on the row rather than on the button, which is why the strike
 * through came from the input's own disabled state instead.
 * Inline display, so no stylesheet rule has to win a specificity fight.
 */
const optionButton = element.closest(".button--variant");
if (optionButton) {
optionButton.classList.toggle("disabled", !availableElement);
optionButton.style.display = availableElement ? "" : "none";
}
});
}
onClickOptionRadioInputs(event) {
const {
currentVariantId,
currentCheckedOptions,
currentVariantMediaId
} = this.findCurrentVariantFromOptionRadioInputs();
this.clearRadioInputStates(event);
if (currentCheckedOptions.includes(event.target.value)) {
event.target.setAttribute("checked", "");
this.updateVariantStatuses();
}

/*
 * RR 24 Aug 2026. Everything below now reads the SETTLED selection.
 * updateVariantStatuses() can move a later option when an earlier one
 * changes, so the id read before it is the one the customer clicked away
 * from. Price, badge, media and the product link were all being set from
 * that stale id.
 */
const settled = this.findCurrentVariantFromOptionRadioInputs();
const settledVariantId = settled.currentVariantId;
const settledMediaId = settled.currentVariantMediaId;

if (currentCheckedOptions.includes(event.target.value)) {
this.disableAddToCartButons();
this.updatePriceForVariant(settledVariantId);
this.updateDiscountBadgeForVariant(settledVariantId);
}
this.updateFormVariantIdInput();
let allVariantIdsWithImageAvailable = [];
this.querySelectorAll("[data-product-images]").forEach(el => {
el.getAttribute("data-product-images")
.split(",")
.forEach(v => {
allVariantIdsWithImageAvailable.push(v);
});
});
if (allVariantIdsWithImageAvailable.includes(settledVariantId.toString())) {
this.updateMediaForVariant(settledVariantId);
}
if (this.isQuickCart && settledMediaId) {
document
.querySelector("quick-cart-drawer")
.setActiveMedia(settledMediaId);
}
this.querySelectorAll("[data-product-link]").forEach(
linkItem => {
const currentLink = linkItem.getAttribute("href");
if (settledVariantId) {
const newLink =
currentLink.split("?variant=")[0] +
"?variant=" +
settledVariantId;
linkItem.setAttribute("href", newLink);
}
}
);
}
setCartButtonState() {
const { currentVariantAvailable } = this.findCurrentVariantFromOptionRadioInputs();
if (!currentVariantAvailable) return;
this.submitButton?.toggleAttribute(
"disabled",
!currentVariantAvailable
);
}
updateMediaForVariant(currentVariantId) {
if (!currentVariantId) return;
this.querySelectorAll("[data-product-images]").forEach(el => {
el.classList.toggle(
"hidden",
!el
.getAttribute("data-product-images")
.includes(currentVariantId)
);
});
}
updateFormVariantIdInput() {
const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();
const input = this.querySelector('input[name="id"]');
if (currentVariantId && input) {
this.querySelector('input[name="id"]').value = currentVariantId;
}
}
updatePriceForVariant(variantId) {
const selectedVariant = this.variantsObj?.find(
variant => variant.id === variantId
);
if (selectedVariant) {
let priceContainer = this.querySelector(".price__container");
if (!priceContainer) {
const previousElement = this.previousElementSibling;
if (previousElement) {
priceContainer = previousElement.querySelector(
".price__container"
);
}
}
if (!priceContainer) return;
const moneyFormat = priceContainer.dataset.moneyFormat;
const labelPriceRegular = priceContainer.dataset.labelPriceRegular;
const labelPriceSale = priceContainer.dataset.labelPriceSale;
if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
const priceHtml = `
<div class="price__sale">
<div class="price__sale-inner">
<span class="visually-hidden">${labelPriceSale}</span>
<s>${formatPrice(selectedVariant.compare_at_price, moneyFormat)}</s>
<ins>
<span class="visually-hidden">${labelPriceRegular}</span>
${formatPrice(selectedVariant.price, moneyFormat)}
</ins>
</div>
</div>
`;
priceContainer.innerHTML = priceHtml;
} else {
const priceHtml = `
<div class="price__sale">
<div class="price__sale-inner">
<span class="visually-hidden">${labelPriceRegular}</span>
<span>${formatPrice(selectedVariant.price, moneyFormat)}</span>
</div>
</div>
`;
priceContainer.innerHTML = priceHtml;
}
}
}
updateDiscountBadgeForVariant(variantId) {
const selectedVariant = this.variantsObj?.find(
variant => variant.id === variantId
);
if (selectedVariant) {
let discountBadge = this.querySelector(
".product-card__badge--discount"
);
if (!discountBadge) {
const previousElement = this.previousElementSibling;
if (previousElement) {
discountBadge = previousElement.querySelector(
".product-card__badge--discount"
);
}
}
if (discountBadge) {
if (
selectedVariant.compare_at_price > selectedVariant.price
) {
discountBadge.classList.remove("hidden");
const percentageElement =
discountBadge.querySelector(".percentage");
if (!percentageElement) return;
const discountPercentage = Math.round(
((selectedVariant.compare_at_price -
selectedVariant.price) /
selectedVariant.compare_at_price) *
100
);
percentageElement.textContent = discountPercentage;
} else {
discountBadge.classList.add("hidden");
}
}
}
}
disableCheckedVariantOptions() {
this.querySelectorAll(
".variant-option-radio-input[checked]"
).forEach(variantBtn => {
if (this.isQuickCart) {
variantBtn.setAttribute("disabled", "");
} else {
variantBtn.removeAttribute("disabled");
}
});
}
disableAddToCartButons() {
const { currentVariantAvailable } =
this.findCurrentVariantFromOptionRadioInputs();
const submitBtn = this.querySelector(
".product-card__add-to-cart--form button[type='submit']"
);
if (
submitBtn &&
!submitBtn.classList.contains(
"product-card__add-to-cart--button"
)
) {
if (!currentVariantAvailable) {
submitBtn.setAttribute("disabled", "");
} else {
submitBtn.removeAttribute("disabled");
}
}
}
clearRadioInputStates(event) {
event.target
.closest(".js-product-card-options")
.querySelectorAll(".variant-option-radio-input")
.forEach(radioInput => {
radioInput.removeAttribute("checked");
});
}
findCurrentVariantFromOptionRadioInputs() {
let currentVariantAvailable = null;
let currentVariantId = "";
let currentVariantMediaId = "";
let currentCheckedOptions = [];
this.querySelectorAll(".js-product-card-options").forEach(
item => {
if (!item.parentNode.classList.contains("hidden")) {
item
.querySelectorAll('input[type="radio"]')
.forEach(radioInput => {
if (radioInput.checked) {
currentCheckedOptions.push(radioInput.value);
}
});
} else {
currentCheckedOptions.push(
item.querySelector('input[type="radio"]').value
);
}
}
);
this.variantsObj?.forEach(item => {
if (
item.options.join() === currentCheckedOptions.join() ||
(item.options.length === 1 &&
currentCheckedOptions.length === 0)
) {
currentVariantId = item.id;
currentVariantAvailable = item.available;
currentVariantMediaId = item.featured_media?.id || null;
}
});
return {
currentVariantAvailable,
currentVariantId,
currentCheckedOptions,
currentVariantMediaId
};
}
findAndDisableAllUnavailableOptionsForSelectedVariant(
selectedOption
) {
let selectedOptionName = "";
if (selectedOption) {
selectedOptionName = selectedOption.value;
} else {
selectedOptionName = this.querySelectorAll(
".variant-option-radio-input"
)[0].value;
}
const { currentCheckedOptions } =
this.findCurrentVariantFromOptionRadioInputs();
const optionIndex =
currentCheckedOptions.indexOf(selectedOptionName) + 1;
this.variantsObj.forEach(item => {
if (
item[`option${optionIndex}`] === selectedOptionName &&
!item.available
) {
[1, 2, 3].forEach(i => {
if (i !== optionIndex && item[`option${i}`]) {
const itemToDisable = this.querySelector(
`.variant-option-radio-input[value="${
item[`option${i}`]
}"]`
);
itemToDisable.closest("li").classList.add("disabled");
}
});
}
});
}
getVariantsData() {
const variantsObj = JSON.parse(
this.querySelector("[data-product-variants-json]")
? this.querySelector("[data-product-variants-json]")
.textContent
: "[]"
);
if (variantsObj && Object.keys(variantsObj).length === 0)
return false;
this.variantsObj = variantsObj;
return variantsObj;
}
secondImgHoverStates() {
const hoverableItem = this.querySelector(
".product-card__actions"
);
if (!hoverableItem || DeviceDetector.isMobile()) {
return;
}
hoverableItem.addEventListener("mouseenter", () =>
hoverableItem.classList.add("is--hovering")
);
hoverableItem.addEventListener("mouseleave", () =>
hoverableItem.classList.remove("is--hovering")
);
}
imageBorderCalc() {
const images = document.querySelectorAll(".product-swatch__inner-border--enable img");
if(images) {
images.forEach((image) => {
if (image.complete) {
processImage(image);
} else {
image.onload = () => processImage(image);
}
});
}
function processImage(image) {
const canvas = document.createElement("canvas");
const ctx = canvas.getContext("2d");
const width = image.naturalWidth || image.width;
const height = image.naturalHeight || image.height;
canvas.width = width;
canvas.height = height;
ctx.drawImage(image, 0, 0, width, height);
const centerX = Math.floor(width / 2);
const centerY = Math.floor(height / 2);
const pixelData = ctx.getImageData(centerX, centerY, 1, 1).data;
const r = pixelData[0];
const g = pixelData[1];
const b = pixelData[2];
const darkenFactor = 0.8;
const darkenedR = Math.max(0, Math.floor(r * darkenFactor));
const darkenedG = Math.max(0, Math.floor(g * darkenFactor));
const darkenedB = Math.max(0, Math.floor(b * darkenFactor));
const darkenedColor = `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`;
image.style.borderColor = darkenedColor;
}
}
initVideoHover() {
const mediaContainer = this.querySelector(".product-card__media");
if (!mediaContainer || !mediaContainer.dataset.hasVideo) {
return;
}
const videoUrl = mediaContainer.dataset.videoUrl;
const videoType = mediaContainer.dataset.videoType;
const playButton = this.querySelector(".product-card__video-play-btn");
if (!videoUrl) return;
let isVideoPlaying = false;
if (!DeviceDetector.isMobile()) {
const hoverableItem = this.querySelector(".product-card__actions");
if (hoverableItem) {
hoverableItem.addEventListener("mouseenter", () => {
if (!isVideoPlaying) {
this.createAndPlayVideo(mediaContainer, videoUrl, videoType);
isVideoPlaying = true;
}
});
hoverableItem.addEventListener("mouseleave", () => {
if (isVideoPlaying) {
this.stopAndRemoveVideo(mediaContainer);
isVideoPlaying = false;
}
});
}
if (playButton) {
playButton.style.display = 'none';
}
}
else {
if (playButton) {
playButton.addEventListener("click", (e) => {
e.preventDefault();
e.stopPropagation();
if (!isVideoPlaying) {
this.createAndPlayVideo(mediaContainer, videoUrl, videoType);
playButton.style.display = 'none';
isVideoPlaying = true;
const closeBtn = document.createElement('button');
closeBtn.className = 'product-card__video-close-btn';
closeBtn.innerHTML = '&times;';
closeBtn.setAttribute('aria-label', 'Close video');
mediaContainer.appendChild(closeBtn);
closeBtn.addEventListener('click', (e) => {
e.preventDefault();
e.stopPropagation();
this.stopAndRemoveVideo(mediaContainer);
playButton.style.display = 'flex';
closeBtn.remove();
isVideoPlaying = false;
});
}
});
}
}
}
createAndPlayVideo(container, videoUrl, videoType) {
let existingVideo = container.querySelector('.product-card__video-element');
if (existingVideo) {
return;
}
if (videoType === 'video') {
const video = document.createElement('video');
video.className = 'product-card__video-element';
video.src = videoUrl;
video.autoplay = true;
video.muted = true;
video.loop = true;
video.playsInline = true;
video.setAttribute('playsinline', '');
container.appendChild(video);
video.play().catch(err => {
console.warn(err);
});
} else if (videoType === 'external_video') {
const iframe = document.createElement('iframe');
iframe.className = 'product-card__video-element';
iframe.src = videoUrl;
iframe.allow = 'autoplay; muted';
iframe.setAttribute('allowfullscreen', '');
iframe.setAttribute('frameborder', '0');
container.appendChild(iframe);
}
}
stopAndRemoveVideo(container) {
const video = container.querySelector('.product-card__video-element');
if (video) {
if (video.tagName === 'VIDEO') {
video.pause();
video.currentTime = 0;
}
video.remove();
}
}
}
customElements.define("product-card", ProductCard);
}
async function updateCartCounters() {
const headerCartCounters = document.querySelectorAll('.cart-count-badge');
const drawerCartCounters = document.querySelectorAll('.cart-drawer__title-counter');
const cartCounters = [...headerCartCounters, ...drawerCartCounters].filter(counter => counter !== null);
try {
const response = await fetch(`${routes.cart_url}.json`, {
method: "GET",
headers: {
"Content-Type": "application/json"
}
});
const state = await response.text();
const parsedState = JSON.parse(state);
if (cartCounters.length > 0) {
cartCounters.forEach(counter => {
counter.textContent = parsedState.item_count;
});
}
if (headerCartCounters.length > 0) {
headerCartCounters.forEach(counter => {
counter.classList.toggle("hidden", parsedState.item_count === 0);
});
}
} catch (error) {
console.error("Cart counters could not be updated:", error);
}
}
async function updateFreeShipping() {
const conversionRate = Shopify.currency.rate;
const {
cart_free_shipping_text: freeShippingTextDefault,
cart_free_shipping_text_success: freeShippingTextSuccessDefault,
cart_free_shipping_threshold: freeShippingThreshold,
money_format: moneyFormat
} = window.theme.settings;
const freeShippingElements = document.querySelectorAll("shipping-bar");
try {
const response = await fetch("/cart.js");
const { total_price, item_count } = await response.json();
const visibility = item_count == 0 ? "hidden" : "visible";
freeShippingElements.forEach(
el => (el.style.visibility = visibility)
);
const newShippingThreshold = Math.round(freeShippingThreshold * conversionRate);
const newRemainingAmount = newShippingThreshold - total_price;
freeShippingElements.forEach(freeShipping => {
const freeShippingTextElement = freeShipping.querySelector(".progress-bar__text");
const progressBarInner = freeShipping.querySelector("[data-progress-line]");
if (total_price >= newShippingThreshold) {
freeShippingTextElement.innerHTML = freeShippingTextSuccessDefault;
progressBarInner.style.width = "100%";
} else {
const moneyMatch = freeShippingTextDefault.match(/<span class="money">(.*)<\/span>/);
if (moneyMatch) {
const newFreeShippingText = freeShippingTextDefault.replace(
moneyMatch[1],
`${formatPrice(newRemainingAmount, moneyFormat)}`
);
freeShippingTextElement.innerHTML = newFreeShippingText;
}
progressBarInner.style.width = `calc(${(total_price / newShippingThreshold) * 100}% + 2px)`;
}
});
} catch (error) {
console.error("Error fetching cart data:", error);
}
}
function formatPrice(amount, moneyString) {
if (amount !== null && amount !== undefined) {
amount = parseFloat(amount) / 100;
} else {
return ''; 
}
const money_format = /{{(.*?)}}/;
let money_format_option = "";
if (moneyString.match(money_format)) {
money_format_option = moneyString.match(money_format)[1];
} else {
console.error("No match found");
}
let newValue = "";
switch (money_format_option) {
case "amount":
newValue = moneyString.replace(
money_format,
Intl.NumberFormat(Shopify.locale, {
minimumFractionDigits: 2,
maximumFractionDigits: 2
}).format(amount)
);
break;
case "amount_with_comma_separator":
newValue = moneyString.replace(
money_format,
amount.toString().replace(".", ",")
);
break;
case "amount_no_decimals":
newValue = moneyString.replace(
money_format,
Math.round(amount)
);
break;
case "amount_no_decimals_with_comma_separator":
newValue = moneyString.replace(
money_format,
Intl.NumberFormat(Shopify.locale)
.format(Math.round(amount))
.toString()
.replace(".", ",")
);
break;
default:
newValue = moneyString.replace(money_format, amount);
break;
}
return newValue;
}
class SwiperComponent extends HTMLElement {
constructor() {
super();
this.swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};
this.swiperInitialized = false; 
this.section = this.closest("section");
this.observer = null;
}
connectedCallback() {
if (this.section && this.section.classList.contains("shopify-section")) {
this.observer = new IntersectionObserver((entries, observer) => {
entries.forEach((entry) => {
if (entry.isIntersecting) {
this.init(); 
observer.disconnect(); 
}
});
});
this.observer.observe(this.section); 
}
if (Shopify.designMode) {
window.addEventListener("shopify:section:load", () => this.init());
window.addEventListener("shopify:section:select", () => this.init());
setTimeout(() => {
if (!this.swiperInitialized) this.init();
}, 100);
} else {
window.addEventListener("load", () => this.init());
}
}
init() {
if (this.swiperInitialized) return; 
this.swiperInitialized = true;
const swiperOptions = this.swiperOptions;
const option = {
slideshowId: swiperOptions.swiperId || "",
slideCount: swiperOptions.slideCount || 1,
slidesPerView: swiperOptions.slidesPerView || "auto",
slidesPerViewDesktop:
swiperOptions.slidesPerViewDesktop ||
swiperOptions.slidesPerView ||
4,
slidesPerViewTablet:
swiperOptions.slidesPerViewTablet ||
swiperOptions.slidesPerViewDesktop ||
swiperOptions.slidesPerView ||
3,
spaceBetween: swiperOptions.spaceBetweenMobile || 0,
spaceBetweenDesktop:
swiperOptions.spaceBetweenDesktop ||
swiperOptions.spaceBetween ||
0,
spaceBetweenTablet:
swiperOptions.spaceBetweenTablet ||
swiperOptions.spaceBetweenDesktop ||
swiperOptions.spaceBetweenMobile ||
0,
enabled: swiperOptions.enabled ?? true,
enabledDesktop:
swiperOptions.enabledDesktop ?? swiperOptions.enabled ?? true,
enabledTablet:
swiperOptions.enabledTablet ??
swiperOptions.enabledDesktop ??
swiperOptions.enabled ??
true,
allowTouchMove:
swiperOptions.allowTouchMove ??
(typeof swiperOptions.slidesPerView === "number"
? swiperOptions.slideCount > swiperOptions.slidesPerView
? true
: false
: true),
allowTouchMoveTablet:
swiperOptions.allowTouchMoveTablet ??
(typeof swiperOptions.slidesPerViewTablet === "number"
? swiperOptions.slideCount > swiperOptions.slidesPerViewTablet
? true
: false
: true),
allowTouchMoveDesktop:
swiperOptions.allowTouchMoveDesktop ??
(typeof swiperOptions.slidesPerViewDesktop === "number"
? swiperOptions.slideCount > swiperOptions.slidesPerViewDesktop
? true
: false
: true)
};
this.swiperOptions = {
a11y: false,
allowTouchMove: option.allowTouchMove,
loop: swiperOptions.loop || false,
rewind: swiperOptions.rewind || false,
followFinger: swiperOptions.followFinger || false,
cssMode: swiperOptions.cssMode || false,
enabled: option.enabled,
watchOverflow: true,
observer: true,
cache: true,
slidesPerView: option.slidesPerView,
spaceBetween: option.spaceBetween,
breakpoints: {
750: {
enabled: option.enabledTablet,
allowTouchMove: option.allowTouchMoveTablet,
slidesPerView: option.slidesPerViewTablet,
spaceBetween: option.spaceBetweenTablet
},
990: {
enabled: option.enabledDesktop,
allowTouchMove: option.allowTouchMoveDesktop,
slidesPerView: option.slidesPerViewDesktop,
spaceBetween: option.spaceBetweenDesktop
}
}
};
if (swiperOptions.navigation) {
this.swiperOptions.navigation = {
...swiperOptions.navigation
};
}
if (swiperOptions.effect == "fade") {
this.swiperOptions.effect = "fade";
this.swiperOptions.fadeEffect = {
crossFade: true
};
}
if (swiperOptions.pagination == "custom_bullet") {
this.swiperOptions.pagination = {
el: swiperOptions.paginationElement,
clickable: true,
renderBullet: function (i, className) {
return `
<button class="${className}">
<span></span>
</button>
`;
}
};
} else {
this.swiperOptions.pagination = {
el: `.swiper-pagination--${swiperOptions.swiperId}`,
clickable: true
};
}
if (swiperOptions.autoplay) {
this.swiperOptions.autoplay = {
...swiperOptions.autoplay
};
if (swiperOptions.autoplayProgress) {
const progressCircle = this.querySelector(
`.autoplay-progress--${swiperOptions.swiperId} svg`
);
const progressContent = this.querySelector(
`.autoplay-progress--${swiperOptions.swiperId} span`
);
this.swiperOptions.on = {
autoplayTimeLeft(s, time, progress) {
progressCircle.style.setProperty("--progress", 1 - progress);
progressContent.textContent = `${Math.ceil(time / 1000)}`;
},
};
}
}
this.swiper = new Swiper(this, {
...this.swiperOptions
});
}
}
customElements.define("swiper-component", SwiperComponent);